import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

@Component({
  selector: 'app-voucher-list',
  // standalone: true,
  // imports: [],
  templateUrl: './voucher-list.component.html',
  styleUrl: './voucher-list.component.scss'
})
export class VoucherListComponent implements OnInit {

//  repId!: number;
//   month!: number;
//   year!: number;
  vouchers: any[] = [];
  loading = true;
  error = '';
  // rep_name: any
  // monthYear: any

  repId: string = '';   
  month: string = '';   
  year: string = '';

  rep_name: string = '';
  monthYear: string = '';

  constructor(
    private route: ActivatedRoute,
    private service: DigisubservicesService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.repId = params['rep'] || '';       
 console.log(this.repId);

      if (this.repId) {
        this.loadSubscribers();
      } else {
        this.error = 'Invalid Representative';
        this.loading = false;
      }

        // this.loadSubscribers();
      
    });
  }

  getMarathiMonthYear(monthParam: string, yearParam: string): string {
    const monthsMarathi = [
      'जानेवारी',
      'फेब्रुवारी',
      'मार्च',
      'एप्रिल',
      'मे',
      'जून',
      'जुलै',
      'ऑगस्ट',
      'सप्टेंबर',
      'ऑक्टोबर',
      'नोव्हेंबर',
      'डिसेंबर'
    ];

    const monthNum = parseInt(monthParam, 10);  // expects 1–12
    const yearNum = parseInt(yearParam, 10);

    if (!isNaN(monthNum) && monthNum >= 1 && monthNum <= 12 && !isNaN(yearNum)) {
      return `${monthsMarathi[monthNum - 1]} - ${yearNum}`;
    }

    const today = new Date();

    // Move to next month
    const nextMonthDate = new Date(today.getFullYear(), today.getMonth() + 1, 1);

    const monthName = monthsMarathi[nextMonthDate.getMonth()];
    const year = nextMonthDate.getFullYear();

    return `${monthName} - ${year}`;
  }

  loadSubscribers(): void {
    this.loading = true;

    // this.service.getVouchersByRep(this.repId, this.month, this.year).subscribe({
          this.service.getVouchersByRep(this.repId).subscribe({
      next: (res) => {
        if (res.status === 'success') {
          this.vouchers = res.data;
          this.rep_name = res.data[0]?.rep_name || '';
          this.error = '';
        } else {
          this.vouchers = [];
          this.error = 'No vouchers found';
        }
        this.loading = false;
      },
      error: () => {
        this.error = 'Failed to load vouchers';
        this.loading = false;
      }
    });

  }

}
